import React from 'react';
import { Link } from 'react-router-dom';

const footerCSS = `
#bvm-footer, #bvm-footer *, #bvm-footer a, #bvm-footer span, #bvm-footer p, #bvm-footer div, #bvm-footer h4 {
  margin: 0;
  padding: 0;
  border: none;
  background: none;
  box-shadow: none;
  text-shadow: none;
  text-decoration: none;
  font-size: 12px;
  line-height: 1.6;
  color: #a0a0a0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
}
#bvm-footer {
  background: #111;
  padding: 20px 24px 12px;
}
#bvm-footer .fg {
  display: grid;
  grid-template-columns: 1fr;
  gap: 18px;
  max-width: 900px;
  margin: 0 auto;
}
@media (min-width: 640px) {
  #bvm-footer .fg {
    grid-template-columns: 1.2fr 1fr 1fr;
    gap: 24px;
  }
}
#bvm-footer h4 {
  color: #e0e0e0;
  font-size: 13px;
  font-weight: 600;
  margin-bottom: 6px;
}
#bvm-footer .fc-info span { display: block; }
#bvm-footer .fc-info span.co { color: #ccc; font-weight: 600; }
#bvm-footer a { display: block; }
#bvm-footer a:hover { color: #4ade80; }
#bvm-footer .ext::after { content: ' ↗'; font-size: 9px; }
#bvm-footer .fb {
  border-top: 1px solid #333;
  margin: 14px auto 0;
  padding-top: 6px;
  text-align: center;
  max-width: 900px;
}
#bvm-footer .fb span { font-size: 10px; color: #666; }
#bvm-footer .fb a { font-size: 10px; color: #666; display: inline; }
#bvm-footer .fb a:hover { color: #4ade80; }
`;

const Footer = () => (
  <>
    <style>{footerCSS}</style>
    <footer id="bvm-footer">
      <div className="fg">
        <div className="fc-info">
          <h4>Boultbee Vegetation Management</h4>
          <span>1101 Spiller Road, Penticton, BC V2A 6J9</span>
          <a href="tel:1-250-492-0296">(250) 492-0296</a>
          <a href="mailto:steve@weedmanager.com">steve@weedmanager.com</a>
          <a href="https://boultbeetreeandlawncom.wordpress.com/" target="_blank" rel="noopener noreferrer" className="ext">Residential Services</a>
        </div>
        <div>
          <h4>Quick Links</h4>
          <Link to="/services">Services</Link>
          <Link to="/about-us">About Us</Link>
          <Link to="/processes">Our Process</Link>
          <Link to="/ecopractices">IPM Practices</Link>
          <Link to="/faq">FAQ</Link>
          <Link to="/contact">Get a Quote</Link>
        </div>
        <div>
          <h4>Industries & Areas</h4>
          <Link to="/industries/railroad">Railroads</Link>
          <Link to="/industries/oil-gas">Oil & Gas</Link>
          <Link to="/industries/municipal">Municipalities</Link>
          <Link to="/industries/utility">Utilities</Link>
          <Link to="/service-areas/lower-mainland">Lower Mainland</Link>
          <Link to="/service-areas/okanagan">Okanagan</Link>
          <Link to="/service-areas/interior-bc">Interior BC</Link>
          <Link to="/service-areas/kootenays">Kootenays</Link>
          <Link to="/service-areas/northern-bc">Northern BC</Link>
        </div>
      </div>
      <div className="fb">
        <span>&copy; {new Date().getFullYear()} Boultbee Vegetation Management &middot; </span>
        <Link to="/privacy-policy">Privacy Policy</Link>
      </div>
    </footer>
  </>
);

export default Footer;
